/* LOOPTD theme behaviour.
   Cart state lives in Shopify (/cart.js), not in this file. Variant selection
   drives a hidden input that the real product form submits. Nothing here
   invents a price or an availability — those come from the variant data
   Shopify rendered into the page. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- mobile nav + cart drawer ---------------- */
  var mnav   = $('[data-mnav]');
  var drawer = $('[data-drawer]');
  var scrim  = $('[data-scrim]');

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function toggle(el, on) {
    if (!el) return;
    el.classList.toggle('is-open', on);
    if (scrim) scrim.classList.toggle('is-open', on);
    lock(on);
    if (on) {
      var f = el.querySelector('button, a, input');
      if (f) f.focus();
    }
  }

  $$('[data-nav-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = !mnav.classList.contains('is-open');
      toggle(mnav, open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  $$('[data-nav-close]').forEach(function (b) {
    b.addEventListener('click', function () { toggle(mnav, false); });
  });
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  $$('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', function () { toggle(drawer, false); });
  });
  if (scrim) scrim.addEventListener('click', function () { toggle(mnav, false); toggle(drawer, false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { toggle(mnav, false); toggle(drawer, false); }
  });

  /* ---------------- cart ---------------- */
  function money(cents) {
    return (window.LOOPTD && window.LOOPTD.moneyFormat)
      ? window.LOOPTD.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      : '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    var body  = $('[data-cart-body]');
    var total = $('[data-cart-total]');
    var count = $$('[data-cart-count]');
    count.forEach(function (c) { c.textContent = cart.item_count; });
    if (total) total.textContent = money(cart.total_price);
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">Your cart is empty.</p>';
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="68" height="85">' : '<span></span>';
      return '<div class="line">' + img +
        '<div><p class="line__t">' + i.product_title + '</p>' +
        (i.variant_title ? '<p class="line__v">' + i.variant_title + '</p>' : '') +
        '<div class="qtybox"><button type="button" data-cart-qty="' + i.key + '" data-dir="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + i.quantity + '</span>' +
        '<button type="button" data-cart-qty="' + i.key + '" data-dir="1" aria-label="Increase quantity">+</button></div></div>' +
        '<span class="line__p">' + money(i.line_price) + '</span></div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function openCart() { toggle(drawer, true); fetchCart(); }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (!q) return;
    var key = q.getAttribute('data-cart-qty');
    var dir = parseInt(q.getAttribute('data-dir'), 10);
    var cur = parseInt(q.parentNode.querySelector('span').textContent, 10) || 0;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, cur + dir) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* add to cart without leaving the page.
     If an add-on box is ticked, the part and the add-on go up in ONE request as
     an items array, so the two either both land in the cart or neither does —
     no half-added order if the second call fails. */
  $$('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;              // no JS fetch: let the form post normally
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      if (!idField) return;

      var qty = parseInt(qtyField ? qtyField.value : '1', 10) || 1;
      var items = [{ id: parseInt(idField.value, 10), quantity: qty }];

      // any line item properties on the form travel with the main item
      var props = {};
      $$('[name^="properties["]', form).forEach(function (p) {
        if (p.type === 'checkbox' && !p.checked) return;
        var key = p.name.slice('properties['.length, -1);
        if (p.value) props[key] = p.value;
      });
      if (Object.keys(props).length) { items[0].properties = props; }

      var addon = form.querySelector('[data-addon-id]:checked:not(:disabled)');
      if (addon) {
        items.push({ id: parseInt(addon.getAttribute('data-addon-id'), 10), quantity: qty });
      }

      if (btn) { btn.disabled = true; }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) { throw new Error('add failed'); }
        return r.json();
      })
        .then(function () { return fetchCart(); })
        .then(function () { toggle(drawer, true); })
        .catch(function () { form.submit(); })   // fall back to a normal post
        .finally(function () { if (btn) { btn.disabled = false; } });
    });
  });

  fetchCart();

  /* ---------------- variant picker ----------------
     Each [data-variants] block holds the real variant list rendered by Liquid.
     Selecting options finds the matching variant and updates the hidden id,
     the price, and the button state. Availability is Shopify's, not ours. */
  $$('[data-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); }
    catch (err) { return; }

    var idInput  = root.querySelector('[name="id"]');
    var priceOut = root.querySelector('[data-price-out]');
    var addBtn   = root.querySelector('[type="submit"]');
    var addLabel = addBtn ? addBtn.textContent : '';

    function chosen() {
      return $$('.opts__set', root).map(function (g) {
        var c = g.querySelector('[aria-checked="true"]');
        return c ? c.getAttribute('data-value') : null;
      });
    }

    function match() {
      var want = chosen();
      return data.filter(function (v) {
        return want.every(function (w, i) { return w === null || v.options[i] === w; });
      })[0];
    }

    function sync() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceOut) {
        priceOut.textContent = v.available ? money(v.price) : 'Sold out';
        priceOut.classList.toggle('is-sold', !v.available);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : 'Sold out';
      }
      // mark option buttons that lead to nothing purchasable, and show what an
      // upgrade costs. An option priced above the current selection reads as an
      // add-on ("Blue-burnt +$5.00") instead of the price silently changing.
      $$('.opts__set', root).forEach(function (g, gi) {
        $$('.chip', g).forEach(function (c) {
          var probe = chosen();
          probe[gi] = c.getAttribute('data-value');

          var candidates = data.filter(function (v2) {
            return probe.every(function (w, i) { return w === null || v2.options[i] === w; });
          });

          // cheapest buyable combination this option leads to
          var buyable = candidates.filter(function (v2) { return v2.available; });
          var ref = buyable.length
            ? buyable.reduce(function (a, b) { return b.price < a.price ? b : a; })
            : null;

          if (c.dataset.label === undefined) { c.dataset.label = c.textContent.trim(); }
          var delta = (ref && v) ? ref.price - v.price : 0;
          var uplift = c.querySelector('.chip__delta');
          if (delta > 0) {
            if (!uplift) {
              uplift = document.createElement('span');
              uplift.className = 'chip__delta';
              c.appendChild(uplift);
            }
            uplift.textContent = '+' + money(delta);
          } else if (uplift) {
            uplift.remove();
          }

          var any = buyable.length > 0;
          if (any) { c.removeAttribute('data-soldout'); }
          else { c.setAttribute('data-soldout', 'true'); }
        });
      });
    }

    $$('.opts__set', root).forEach(function (grp) {
      var chips = $$('.chip', grp);
      chips.forEach(function (chip, i) {
        function select(move) {
          chips.forEach(function (o) { o.setAttribute('aria-checked', 'false'); o.tabIndex = -1; });
          chip.setAttribute('aria-checked', 'true');
          chip.tabIndex = 0;
          if (move) chip.focus();
          sync();
        }
        chip.addEventListener('click', function () { select(false); });
        chip.addEventListener('keydown', function (ev) {
          var n = -1;
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') n = (i + 1) % chips.length;
          else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') n = (i - 1 + chips.length) % chips.length;
          else if (ev.key === 'Home') n = 0;
          else if (ev.key === 'End') n = chips.length - 1;
          else return;
          ev.preventDefault();
          chips[n].click();
          chips[n].focus();
        });
      });
    });

    sync();
  });

  /* ---------------- product gallery ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gal-main]');
    $$('[data-gal-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (main && full) { main.src = full; main.alt = t.getAttribute('data-alt') || ''; }
        $$('[data-gal-thumb]', g).forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------------- accordions ---------------- */
  $$('[data-acc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
    });
  });

  /* ---------------- quantity steppers on the PDP ---------------- */
  $$('[data-qty]').forEach(function (w) {
    var out = w.querySelector('[data-qty-n]');
    var field = w.querySelector('input[name="quantity"]');
    $$('[data-qstep]', w).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = b.getAttribute('data-qstep') === 'up' ? 1 : -1;
        var n = Math.max(1, (parseInt(out.textContent, 10) || 1) + d);
        out.textContent = n;
        if (field) field.value = n;
      });
    });
  });
})();
